import { render, staticRenderFns } from "./EmployeeDesc.vue?vue&type=template&id=2f2a50ba"
import script from "./EmployeeDesc.vue?vue&type=script&lang=js"
export * from "./EmployeeDesc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports